import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import ApProcessedEmailsContainer from '../../containers/apAutomation/ApProcessedEmails';
import AuthUserContainer from '../../containers/AuthUser';
import RegistryContainer from '../../containers/Registry';

import EnhancedTable from '../../components/table/EnhancedTable';
import { getSharedStyles } from '../../themes';

import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import ErrorIcon from '../../images/icons/error.svg';
import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 1,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	label: {
		paddingRight: 5,
		textTransform: 'uppercase',
		fontSize: '85%',
		color: '#555',
	},
});

const apColumns = [
	{
		sortId: 'apProcessedEmailId',
		displayId: 'apProcessedEmailId',
		labels: ['AP Email ID'],
	},
	{
		sortId: 'emailSubject',
		displayId: 'emailDetails',
		label: 'Email Info',
	},
	{
		sortId: 'dateCreated',
		displayId: 'dateCreatedFormatted',
		label: 'Date Processed',
	},
	{
		sortId: 'attachmentCount',
		displayId: 'attachmentDetails',
		label: 'Attachment Info',
	},
	{
		sortId: 'emailStatus',
		displayId: 'emailStatusDisplay',
		label: 'Email Status',
	},
];

const afterDate = moment().subtract({ days: 10 }).format('YYYY-MM-DD');

function getRegValue(registryRows, name) {
	return _.get(_.find(registryRows, { name }), 'val');
}

class ApProcessedEmails extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'apProcessedEmailId',
			search: '',
			filterMap: {},
			isViewDialogOpen: false,
		};
	}

	componentDidMount() {
		const { apProcessedEmails, apProcessedEmailSearch } = this.props;

		if (!apProcessedEmails) {
			apProcessedEmailSearch({ afterDate });
		} else {
			this.formatApProcessedEmails();
		}

		if (!this.props.registryRows) {
			this.props.searchRegistry({});
		}
	}

	componentDidUpdate(prevProps) {
		const { apProcessedEmails, registryRows } = this.props;
		if (prevProps.apProcessedEmails !== apProcessedEmails) {
			this.formatApProcessedEmails();
		}

		if (!prevProps.registryRows && registryRows) {
			const apEmailImportRegistry = getRegValue(registryRows, 'apEmailImport');
			this.setState({
				apEmailImportRegistry,
			});
		}
	}
	refreshTable = () => {
		const { apProcessedEmailSearch } = this.props;
		this.setState({ formattedApProcessedEmails: undefined });
		apProcessedEmailSearch({ afterDate });
	};

	formatApProcessedEmails = () => {
		const { classes } = this.props;
		const { apProcessedEmails } = this.props;
		const formattedApProcessedEmails = [];
		apProcessedEmails.forEach((apProcessedEmail) => {
			const {
				apProcessedEmailId,
				emailFrom,
				emailSubject,
				apProcessedEmailAttachments,
				dateCreated,
				emailStatus,
			} = apProcessedEmail;

			apProcessedEmail.key = apProcessedEmailId;
			apProcessedEmail.dateCreatedFormatted = (
				<div>
					<div>{moment(dateCreated).format('M/D/YY h:mm a')}</div>
				</div>
			);

			apProcessedEmail.emailDetails = (
				<div>
					<div>{emailFrom}</div>
					<div>{emailSubject}</div>
				</div>
			);

			apProcessedEmail.attachmentCount = apProcessedEmailAttachments.length;

			apProcessedEmail.attachmentDetails = (
				<div>
					<div>Document Count: {apProcessedEmailAttachments.length}</div>
					{apProcessedEmailAttachments.map((attachment) => {
						const { filename, originalFilename, apIngestionId } = attachment;
						console.log('org', originalFilename);
						return (
							<div key={attachment.apProcessedEmailAttachmentsId}>
								<span style={{ paddingRight: 3 }}>{filename}</span>
								{!!originalFilename && (
									<span style={{ paddingRight: 3, fontStyle: 'italic', color: '#777' }}>
										({originalFilename})
									</span>
								)}
								<span>/ Ingestion Id:{apIngestionId}</span>
							</div>
						);
					})}
				</div>
			);

			apProcessedEmail.emailStatus = emailStatus;
			if (emailStatus === 'badAttachment') {
				apProcessedEmail.emailStatusDisplay = (
					<div>
						<span className={classes.warningIconSmall} /> {_.startCase(emailStatus)}
					</div>
				);
			} else if (emailStatus === 'noAttachments') {
				apProcessedEmail.emailStatusDisplay = (
					<div>
						<span className={classes.warningIconSmall} /> {_.startCase(emailStatus)}
					</div>
				);
			} else {
				apProcessedEmail.emailStatusDisplay = (
					<div>
						<span className={classes.greenCheckedIconSmall} />{' '}
						{_.startCase(emailStatus || 'processed')}
					</div>
				);
			}

			formattedApProcessedEmails.push(apProcessedEmail);
		});
		this.setState({ formattedApProcessedEmails });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewFuelContract: undefined,
		});
	};

	render() {
		const { classes } = this.props;
		const { formattedApProcessedEmails, order, orderBy, apEmailImportRegistry } = this.state;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>AP Email Processor Status</span>
							</Typography>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						{apEmailImportRegistry && (
							<Grid container spacing={3}>
								<Grid item xs={6}>
									<div>
										<FMPSectionHeader label={'Last Run Information'} isTop={true} />

										<div style={{ marginTop: 4 }}>
											<span className={classes.label}>Pending Emails: </span>
											<span>{apEmailImportRegistry.pending}</span>
										</div>

										<div
											style={{
												fontSize: '85%',
												color: '#666',
												fontStyle: 'italic',
												marginTop: 4,
												paddingLeft: 10,
											}}
										>
											Note: Pending emails are usually due to waiting 24 hours before process new
											emails.
										</div>

										<div style={{ marginTop: 4 }}>
											<span className={classes.label}>Processed Emails: </span>
											<span>{apEmailImportRegistry.processed}</span>
										</div>

										<div style={{ marginTop: 4 }}>
											<span className={classes.label}>Last Run At: </span>
											<span>
												{moment(apEmailImportRegistry.lastCheck).format('dddd, M/D h:mm a')}
											</span>
										</div>
									</div>
								</Grid>
								<Grid item xs={6}>
									<FMPSectionHeader label={'Run Schedule'} isTop={true} />
									<div>
										The AP email processor runs every 20 minutes all day during the week. It does
										not process any emails until they have been in the inbox for 24 hours. Also the
										FMP does not process any emails on Saturday, Saturday, and Monday before 2pm.
										Reasoning for this schedule is that it gives a buffer for our accounting
										department to get the invoices processed first so they will match the incoming
										bills.
									</div>
								</Grid>
							</Grid>
						)}
					</Paper>
				</Grid>

				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Recent AP Processed Emails</span>
							</Typography>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						{!formattedApProcessedEmails && <div>Loading the ap ingestions...</div>}
						{formattedApProcessedEmails && (
							<EnhancedTable
								columns={apColumns}
								rows={formattedApProcessedEmails}
								defaultOrder={order}
								defaultOrderBy={orderBy}
							/>
						)}
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

ApProcessedEmails.propTypes = {
	classes: PropTypes.object.isRequired,
	apProcessedEmailSearch: PropTypes.func.isRequired,
	apProcessedEmails: PropTypes.array,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,

	searchRegistry: PropTypes.func,
	registryRows: PropTypes.array,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	ApProcessedEmailsContainer,
	RegistryContainer,
])(ApProcessedEmails);
